// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"HomeNewsMobileItem_Wrapper__afiGO","Image":"HomeNewsMobileItem_Image__31Ufp","Name":"HomeNewsMobileItem_Name__3QfZP"};